import { TaskAlt } from "@mui/icons-material"
import EventDetailBanner from "../../../components/Cards/EventDetailBanner"
import VenueLocationSection from "../../../components/event-preview/VenueLocationSection"
import OrganizeBy from "../../../components/event-preview/OrganizeBy"
import ScheduleSection from "../../../components/event-preview/ScheduleSection"
import ShareEvent from "../../../components/event-preview/ShareEvent"
import UserLikesEvents from "../event-management/UserLikesEvents"
import UserPurchaseTicket from "./UserPurchaseTicket"
import TermsAndFaqs from "../../../components/event-preview/TermsAndFaqs"
import EventPreviewSkeleton from "../../../components/event-preview/EventPreviewSkeleton"
import PaymentError from "../../../components/UiComponent/TicketError"
import useTicketOrderPayment from "./hooks/useTicketOrderPayment"
import { H5, Body2, Body3, H4, Body1 } from "../../../themes/typography"
import "../../../styles/event/TicketBookingOrder.css"

export default function TicketOrderPayment() {

    const {
        open,
        anchorEl,
        handleMenuOpen,
        handleMenuClose,
        handleDownloadInvoice,
        handleDownloadTickets,
        loading,
        bookingId,
        orderData,
        fcs,
        numberOfTickets,
        eventTimingUI,
        eventDurationUI,
        eventDate,
        error
    } = useTicketOrderPayment();

    const isSingleDayEventWithSlots =
        orderData?.eventData?.event_type === 'single_day' &&
        orderData?.eventData?.schedules[0]?.slots &&
        orderData?.eventData?.schedules[0]?.slots.length > 0;

    const isMultiDateEvent = orderData?.eventData?.event_type === 'multi_day';

    if (loading) {
        return (
            <div className="page-view">
                <div className="page-wrapper">
                    <EventPreviewSkeleton />
                </div>
            </div>
        )
    }

    // if (error === 'PAYMENT_FAILED' && !loading) {
    //     return (
    //         <div className="page-view">
    //             <div className="page-wrapper">
    //                 <PaymentError />
    //             </div>
    //         </div>
    //     )
    // } else if (error && !loading) {
    //     return (
    //         <div className="page-view">
    //             <div className="page-wrapper">
    //                 <div style={{ padding: '20px', textAlign: 'center' }}>
    //                     <H4>Something went wrong!</H4>
    //                 </div>
    //             </div>
    //         </div>
    //     )
    // }

    return (
        <div className="page-view">
            <div className="page-wrapper">

                <div id="ticket-order-payment-success-container">

                    <SuccessText />

                    <EventDetailBanner
                        thumbnail={orderData?.eventData?.thumbnail}
                        name={orderData?.eventData.title}
                        address={orderData?.eventData.address}
                        fcs={fcs}
                        bookingId={bookingId}
                        date={eventDate}
                        time={eventTimingUI()}
                        noOfTicketsBooked={numberOfTickets}
                        duration={eventDurationUI()}
                        showElipsisMenu={false}
                        showGetTicketButton={false}
                        showDownloadTicketButton={true}
                        openInvoiceMenu={open}
                        anchorElInvoiceMenu={anchorEl}
                        openInvoiceMenuDropdown={handleMenuOpen}
                        closeInvoiceMenu={handleMenuClose}
                        downloadTickets={handleDownloadTickets}
                        downloadInvoice={handleDownloadInvoice}
                    />

                    <div className="event-more-detail-section">
                        <div className="event-details-flexbox-container">

                            <div className="event-detail-left-flex-box">
                                <TicketSentText
                                    invoiceEmail={orderData?.orderData?.invoice_email}
                                />

                                <div className="ticket-ordered-list">
                                    {orderData?.orderData?.ticket_type_info?.map((ticketType, typeIndex) =>
                                        ticketType.tickets?.map((ticket, ticketIndex) => (
                                            <UserPurchaseTicket
                                                key={`${typeIndex}-${ticketIndex}`}
                                                name={ticketType.title}
                                                description={ticketType.description}
                                                attendeeName={ticket.attendee_name}
                                                id={ticket.id}
                                                validFor={ticket?.schedules}
                                            />
                                        ))
                                    )}
                                </div>

                                {/* TODO: Add Terms and FAQs properly */}
                                <TermsAndFaqs />
                            </div>

                            <div className="event-detail-right-flex-box">
                                {(isSingleDayEventWithSlots || isMultiDateEvent) && (
                                    <ScheduleSection previewData={orderData?.eventData} />
                                )}

                                {!orderData?.eventData?.online_event && (
                                    <VenueLocationSection
                                        venueName={orderData?.eventData?.venue}
                                        address={orderData?.eventData?.address}
                                        latitude={orderData?.eventData?.latitude}
                                        longitude={orderData?.eventData?.longitude}
                                    />
                                )}

                                <OrganizeBy organizerName={orderData?.eventData?.creator_name} />

                                <ShareEvent
                                    eventUrl={`http://localhost:3000/e/${orderData?.eventData?.slug}`}
                                    onCopy={() => { navigator.clipboard.writeText(`http://localhost:3000/e/${orderData?.eventData?.slug}`); }}
                                />
                            </div>

                        </div>
                    </div>

                    <UserLikesEvents />

                </div>

            </div>
        </div>
    )
}

function TicketSentText({ invoiceEmail }) {
    return (
        <div className="event-preview-description-container">
            <div>
                <H5 fontWeight={700}>
                    Ticket Details
                </H5>
            </div>

            <div className="event-preview-description">
                <div
                    className="event-preview-description-content"
                >
                    <Body2>
                        We have sent your order confirmation to {invoiceEmail}. Tickets are on the way to the email id's of the attendees provided previously.
                    </Body2>
                    <Body3>
                        Please check your spam folder in case you do not find the ticket in your inbox. Also please mark it “Not Spam”.
                    </Body3>
                </div>
            </div>
        </div>
    )
}

function SuccessText() {
    return (
        <div className="ticket-booked-success-message">

            <div className="ticket-booked-success-icon">
                <TaskAlt
                    sx={{
                        color: 'var(--success-main-color)',
                        fontSize: '5rem'
                    }}
                />
            </div>

            <div className="ticket-booked-success-text">
                <H4>Thank You! Your Booking is Confirmed</H4>
                <Body1>Your Tickets have been successfully booked.</Body1>
            </div>
        </div>
    )
}